<style>
@import '../../custom/css/ver-dica.css';
</style>

<template>
  <div class="ver-dica">
    <div class="form-fields position-relative" v-if="this.dica !== null">
      <h1 class="title text-uppercase font-weight-bold">Ver Dica</h1>
      <hr class="linha-amarela" />
      <div class="form-group">
        <label for="titulo">Título</label>
        <div class="text" id="titulo">{{ dica[0].titulo }}</div>
      </div>
      <div class="form-group">
        <label for="texto_1">Primeiro Texto</label>
        <div class="text" id="texto_1" v-html="dica[0].texto_1"></div>
      </div>
      <div class="form-group">
        <label for="texto_2">Segundo Texto</label>
        <div class="text" id="texto_2" v-html="dica[0].texto_2"></div>
      </div>
      <div class="form-group" v-if="dica[0].imagem !== null">
        <div class="box-img mb-4 shadow h-auto">
          <img
            :src="`${getImagesAddress}` + dica[0].imagem"
            alt="Imagem da dica"
            class="obj-cover w-100"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="video">Vídeo</label>
        <div class="text" id="video">{{ dica[0].video }}</div>
      </div>
      <div class="form-group">
        <label for="categorias_metatags">Categorias Metatags</label>
        <div class="text" id="categorias_metatags">
          {{ dica[0].categorias_metatags }}
        </div>
      </div>
      <div class="form-group">
        <div class="btn btn-success" @click="editarDica()">Editar</div>
        <div class="btn btn-voltar-dicas" @click="voltarLista()">Voltar</div>
      </div>
    </div>
    <div class="form-fields" v-else>
      <h1 class="title text-uppercase">Essa dica não existe mais!</h1>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ver-dica',
  data: () => ({
    dados: {},
  }),
  props: ['id'],
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    ...mapState({
      dica: (state) => state.dica,
    }),
  },
  created() {
    this.$store.dispatch('showDica', this.id);
  },
  activated() {
    this.$store.dispatch('showDica', this.id);
  },
  methods: {
    editarDica() {
      this.$router.push({
        name: 'administrador-editar-dica',
        params: { id: this.id },
      });
    },
    voltarLista() {
      this.$router.push({
        name: 'administrador-lista-dicas',
      });
    },
  },
};
</script>
